<template>
  <div>
    <base-info-card
      :title="title"
      :subtitle="subtitle"
      mobile-size="text-h6"
      space="4"
      color="primary"
    />

    <v-form ref="form">
      <v-row class="compact-form">
        <v-col
          cols="12"
          md="6"
        >
          <base-text-field
            v-model="form.firstName"
            :label="$t('contact.form.firstName')"
            :rules="[rules.required]"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <base-text-field
            v-model="form.lastName"
            :label="$t('contact.form.lastName')"
            :rules="[rules.required]"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <base-text-field
            v-model="form.email"
            :label="$t('contact.form.email')"
            :rules="[rules.required, rules.email]"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <base-text-field
            v-model="form.phone"
            :label="$t('contact.form.phone')"
            :rules="[rules.required]"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <base-text-field
            v-model="form.company"
            :label="$t('contact.form.company')"
            :rules="[rules.required]"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <base-text-field
            v-model="form.country"
            :label="$t('contact.form.country')"
            :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="12">
          <v-select
            v-model="form.interest"
            :items="interestOptions"
            :label="$t('contact.form.interestLabel')"
            outlined
            dense
            hide-details
            class="mb-4"
            :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="12">
          <base-textarea
            v-model="form.message"
            class="mb-4"
            :label="$t('contact.form.message')"
          />
        </v-col>
      </v-row>

      <base-btn
        color="primary"
        :tile="false"
        rounded
        dark
        :loading="submitting"
        :disabled="submitting"
        @click="handleSubmit"
      >
        {{ $t('contact.form.submit') }}
      </base-btn>
    </v-form>
  </div>
</template>

<script>
  export default {
    name: 'BaseContactForm',

    // Injected from the Vuetify Themeable mixin
    inject: ['theme'],

    props: {
      subtitle: String,
      title: {
        type: String,
        default: 'MAIL US YOUR MESSAGE',
      },
    },

    data: () => ({
      submitting: false,
      form: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        company: '',
        country: '',
        interest: '',
        message: '',
      },
      rules: {
        required: v => !!v || 'Required',
        email: v => /.+@.+\..+/.test(v) || 'Invalid email',
      },
    }),

    computed: {
      interestOptions() {
        return this.$i18n.getLocaleMessage(this.$i18n.locale).contact.form.interests
      },
    },

    methods: {
      async handleSubmit() {
        if (this.$refs.form && !this.$refs.form.validate()) return
        this.submitting = true
        try {
          await this.$axios({
            method: 'post',
            url: '/public/leads',
            data: { ...this.form, lang: this.$i18n.locale },
          })
          this.$root.$showSnackbar({
            message: this.$t('contact.form.submitTip'),
            color: 'success',
          })
          this.form = {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            company: '',
            country: '',
            interest: '',
            message: '',
          }
          this.$refs.form.resetValidation()
        } catch (error) {
          this.$root.$showSnackbar({
            message: this.$t('contact.form.submitError'),
            color: 'error',
          })
        } finally {
          this.submitting = false
        }
      },
    },

  }
</script>

<style lang="sass" scoped>
.compact-form .col-12,
.compact-form .col-md-6
  padding-top: 0px
  padding-bottom: 0px
</style>
